var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubProcess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#858A93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEF0F3",
    d: "M29.109 17.16l.646 2.18c.219.752.97 1.199 1.711 1.022l2.15-.511c1.052-.244 2.098.435 2.336 1.518a2.055 2.055 0 0 1-.475 1.812l-1.506 1.666a1.539 1.539 0 0 0 0 2.044l1.506 1.668a2.05 2.05 0 0 1-.1 2.84 1.917 1.917 0 0 1-1.761.49l-2.15-.512c-.74-.173-1.483.272-1.702 1.02l-.647 2.18c-.308 1.056-1.39 1.655-2.418 1.338a1.974 1.974 0 0 1-1.3-1.337l-.653-2.18c-.22-.75-.97-1.2-1.711-1.023l-2.15.512c-1.054.244-2.1-.435-2.337-1.52a2.049 2.049 0 0 1 .476-1.81l1.505-1.668c.519-.576.519-1.466 0-2.043l-1.505-1.667a2.05 2.05 0 0 1 .1-2.84 1.917 1.917 0 0 1 1.761-.49l2.15.511c.742.177 1.49-.27 1.711-1.021l.646-2.18c.31-1.056 1.392-1.656 2.417-1.336a1.965 1.965 0 0 1 1.3 1.337z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.25 24.026a2.303 2.303 0 1 1 0 4.606 2.303 2.303 0 0 1 0-4.606zM14.678 28.632H2.52c-.84 0-1.52-.695-1.52-1.555V5.317c0-.858.68-1.554 1.52-1.554h27.355c.84 0 1.52.696 1.52 1.554V15.42M8.368 1v7.368M24.026 1v7.368M1 12.053h30.395"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubProcess);
export default __webpack_public_path__ + "static/media/sub-process.ba916008be0f318e1c9a2e0ea071d5a0.svg";
export { ForwardRef as ReactComponent };